import { useAuth } from '@merq/web-ui/dist/providers/userProvider';
import { useEffect } from 'react';
import useStore from 'store';
import { UserPermissions } from 'store/Permission/store';

/**
 * A React hook that provides permission checks for a given set of categories.
 * @returns An object with properties to check if a given page has read, edit or admin access.
 */
export const useOauthPermissions = () => {
  const { user } = useAuth();
  const [perms, getPermissions] = useStore(state => [state.permissions, state.getPermissions]);

  useEffect(() => {
    if (user && user.email) {
      getPermissions(user.email);
    }
  }, [user]);

  // TODO: dissconect firebase permissions and use only the ones from the backend
  return perms;
};

export const canView = (actions: string[] = []) =>
  actions.includes('VIEW') || actions.includes('ADMIN') || actions.includes('EDIT');

export const isWebsiteAdmin = ({ website }: UserPermissions['permissions']) => {
  const adminPages = ['adminNews', 'adminDocuments', 'adminIndex', 'adminTeam'];
  return (
    adminPages.filter(page => canView(website[page as keyof typeof website]?.actions)).length > 0
  );
};

export const inQubatorAccess = (permissions: UserPermissions['permissions']) =>
  ((permissions.apis.indexapi.namespacesRead.includes('merqubeinqubator') ||
    permissions.apis.indexapi.namespacesRead.includes('*')) &&
    canView(permissions.website.merqubeInqubator?.actions)) ||
  canView(permissions.website.userInqubator?.actions);

export const hasUserInQubatorAccess = (permissions: UserPermissions['permissions']) => {
  const actions = permissions.website.userInqubator?.actions || [];
  return canView(actions);
};

export const hasMerqubeInQubatorAccess = (permissions: UserPermissions['permissions']) =>
  (permissions.apis.indexapi.namespacesRead.includes('merqubeinqubator') ||
    permissions.apis.indexapi.namespacesRead.includes('*')) &&
  canView(permissions.website.merqubeInqubator?.actions);
